module.exports = __webpack_public_path__ + "static/media/Dreamer maxihörnsoffa sense 4060 ljusgrå detalj 2024 8.1277ee77.jpg";